import { useDevice } from "../../hooks/useDevice";
import { MobileContentWrapper } from "./MobileContentWrapper";
import { WebContentWrapper } from "./WebContentWrapper";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LocalStorageKey from "../../enums/LocalStorageKey";
import { usePrivacyGuard } from "../../hooks/usePrivacyGuard";

export function CommonContentWrapper({ children, isFixed, hasPagination }) {
    const currentDevice = useDevice();
    const navigation = useNavigate();

    usePrivacyGuard();

    useEffect(() => {
        const accessToken = localStorage.getItem(LocalStorageKey.accessToken);
        if (!accessToken) {
            navigation("/auth/init");
        }
    }, [navigation]);

    if (currentDevice === "mobile" || currentDevice === "tablet") {
        return <MobileContentWrapper>{children}</MobileContentWrapper>;
    }
    return (
        <WebContentWrapper isFixed={isFixed} hasPagination={hasPagination}>
            {children}
        </WebContentWrapper>
    );
}
